import axios from 'axios';

// API endpoints for prompt management
const PROMPT_API = {
  generatePrompt: '/api/prompts/generate',
  improvePrompt: '/api/prompts/improve',
  templatizePrompt: '/api/prompts/templatize',
  getAllPrompts: '/api/prompts',
  getPromptById: (id) => `/api/prompts/${id}`,
  createPrompt: '/api/prompts',
  updatePrompt: (id) => `/api/prompts/${id}`,
  deletePrompt: (id) => `/api/prompts/${id}`,
  evaluatePrompt: '/api/prompts/evaluate'
};

// Generate prompt using the Claude API
const generatePrompt = async (promptData) => {
  try {
    const response = await axios.post(PROMPT_API.generatePrompt, promptData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error generating prompt' };
  }
};

// Improve an existing prompt
const improvePrompt = async (promptId, improvementData) => {
  try {
    const response = await axios.post(PROMPT_API.improvePrompt, {
      promptId,
      ...improvementData
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error improving prompt' };
  }
};

// Create a template from an existing prompt
const templatizePrompt = async (promptId, templateData) => {
  try {
    const response = await axios.post(PROMPT_API.templatizePrompt, {
      promptId,
      ...templateData
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error templatizing prompt' };
  }
};

// Get all prompts
const getAllPrompts = async (filters = {}) => {
  try {
    const response = await axios.get(PROMPT_API.getAllPrompts, { params: filters });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching prompts' };
  }
};

// Get a prompt by ID
const getPromptById = async (promptId) => {
  try {
    const response = await axios.get(PROMPT_API.getPromptById(promptId));
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching prompt' };
  }
};

// Create a new prompt
const createPrompt = async (promptData) => {
  try {
    const response = await axios.post(PROMPT_API.createPrompt, promptData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating prompt' };
  }
};

// Update an existing prompt
const updatePrompt = async (promptId, promptData) => {
  try {
    const response = await axios.put(PROMPT_API.updatePrompt(promptId), promptData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating prompt' };
  }
};

// Delete a prompt
const deletePrompt = async (promptId) => {
  try {
    const response = await axios.delete(PROMPT_API.deletePrompt(promptId));
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting prompt' };
  }
};

// Evaluate a prompt
const evaluatePrompt = async (promptData) => {
  try {
    const response = await axios.post(PROMPT_API.evaluatePrompt, promptData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error evaluating prompt' };
  }
};

const promptService = {
  generatePrompt,
  improvePrompt,
  templatizePrompt,
  getAllPrompts,
  getPromptById,
  createPrompt,
  updatePrompt,
  deletePrompt,
  evaluatePrompt
};

export default promptService;